import { Avatar, Box, Divider, IconButton, Typography } from '@mui/material';
import Icon from '../../Assets/Icon/CustomIcon';
import { ArrowForwardIos as RightArrowIcon } from '@mui/icons-material';
import { Badge } from './Badge';
import ProgressBarDefault, { ProgressBarAdmin } from './ProgressBar';
import { useSelector } from 'react-redux';

const flexRow = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const flexCol = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export default function UserInfoCard({
  profileImg = null,
  progress = { current: 0, duration: 200 },
  showProgress = true, // 당월 진행상황
  showDayProgress = false, // 금일 진행상황
  showConstruction = true, // 공정 ui
  showIssuanceNotice = false, // TBM 남은 시간 ui 표시 여부
  showButton = true,
  buttonDisabled = false,
  cardSx = {},
  onClick = () => {},
}) {
  const { userInfo } = useSelector((state) => state.BaseInfo);

  return (
    <Box
      sx={{
        ...flexCol,
        justifyContent: 'center',
      }}
    >
      {/* 사용자 정보 */}
      <Box
        sx={{
          ...flexCol,
          width: '100%',
          px: '16px',
          py: '20px',
          border: ' 1px solid #F3F4F6',
          borderRadius: 4,
          gap: '16px',
          boxSizing: 'border-box',
          backgroundColor: '#FFFFFF',
          ...cardSx,
        }}
      >
        {/* 사용자 이미지 & 정보*/}
        <Box
          sx={{
            width: '100%',
            display: ' flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Box
            sx={{
              ...flexRow,
              width: '48px',
              height: '48px',
              border: ' 1px solid #EEEEEE',
              borderRadius: ' 100%',
              backgroundColor: profileImg ? 'transparent' : '#F2F2F2',
            }}
          >
            {profileImg ? (
              <Avatar
                src={profileImg}
                alt="프로필 이미지"
                sx={{ width: 48, height: 48 }}
              />
            ) : (
              <Icon.User />
            )}
          </Box>
          <Box
            sx={{
              ...flexCol,
              alignItems: 'flex-start',
              gap: '5px',
              mr: 'auto',
            }}
          >
            {/* 사용자 직함 */}
            <Box sx={{ ...flexRow, gap: '10px' }}>
              <Badge authCd={userInfo.authCd} />
            </Box>

            {/* 사용자 이름 */}
            <Box sx={{ ...flexRow, gap: '5px' }}>
              <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                {userInfo.userNm}
              </Typography>
              <Typography sx={{ fontSize: '16px' }}>님</Typography>
            </Box>
          </Box>

          {showButton && (
            <IconButton onClick={(e) => onClick(e)} disabled={buttonDisabled}>
              <RightArrowIcon sx={{ fontSize: '1rem', color: '#000000' }} />
            </IconButton>
          )}
        </Box>

        {/* 공정 */}
        {showConstruction && userInfo.depNm && (
          <>
            <Divider sx={{ width: '100%' }} />
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                <Badge label={userInfo.depNm} />
              </Box>
            </Box>
          </>
        )}

        {/* 프로그레스바 */}
        {showProgress && (
          <>
            <Divider sx={{ width: '100%' }} />
            <ProgressBarDefault
              current={progress.current}
              duration={progress.duration}
              showIssuanceNotice={showIssuanceNotice}
            />
          </>
        )}
        {showDayProgress && (
          <>
            <Divider sx={{ width: '100%' }} />
            <ProgressBarAdmin
              current={progress.current}
              duration={progress.duration}
              showIssuanceNotice={showIssuanceNotice}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
